// extracted by mini-css-extract-plugin
export default {"Notification":"styles_Notification__fu92d","col":"styles_col__uz9hn","title":"styles_title__u8n+p","notifications":"styles_notifications__vKBUi"};